/* eslint-disable object-curly-newline */
/* eslint-disable quotes */
/* eslint-disable react/require-default-props */
/* eslint-disable no-undef */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import React from "react";
import { Item, ItemList, Small } from "./styles";

interface Props {
  name: string;
  icone: JSX.Element;
  nameColor?: string;
}

const ItemUserCheckAll: React.FC<Props> = ({ name, icone, nameColor }) => (
  <ItemList>
    <Item>
      <Small color={nameColor}>{name}</Small>
    </Item>
    {icone}
  </ItemList>
);
export default ItemUserCheckAll;
